import { render, staticRenderFns } from "./bookCategory.vue?vue&type=template&id=6f444169&scoped=true"
import script from "./bookCategory.vue?vue&type=script&lang=js"
export * from "./bookCategory.vue?vue&type=script&lang=js"
import style0 from "./bookCategory.vue?vue&type=style&index=0&id=6f444169&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f444169",
  null
  
)

export default component.exports